import CallCenterOffIcon from './CallCenterOff.icon';

export default CallCenterOffIcon;
